/**
 * @packageDocumentation
 * @module api.functional.admin.invitations.all
 * @nestia Generated by Nestia - https://github.com/samchon/nestia
 */
//================================================================
import type { IConnection } from "@nestia/fetcher";
import { PlainFetcher } from "@nestia/fetcher";

import type { PaginationQuerycompanyIdnumberundefined } from "../../../../structures/PaginationQuerycompanyIdnumberundefined";
import type { ServiceResponse__object } from "../../../../structures/ServiceResponse__object";

/**
 * @controller InvitationController.getAllInvitations
 * @path GET /admin/invitations/all
 * @accessor api.functional.admin.invitations.all.getAllInvitations
 * @nestia Generated by Nestia - https://github.com/samchon/nestia
 */
export async function getAllInvitations(
  connection: IConnection,
  query: getAllInvitations.Query,
): Promise<getAllInvitations.Output> {
  return PlainFetcher.fetch(connection, {
    ...getAllInvitations.METADATA,
    template: getAllInvitations.METADATA.path,
    path: getAllInvitations.path(query),
  });
}
export namespace getAllInvitations {
  export type Query = PaginationQuerycompanyIdnumberundefined;
  export type Output = ServiceResponse__object;

  export const METADATA = {
    method: "GET",
    path: "/admin/invitations/all",
    request: null,
    response: {
      type: "application/json",
      encrypted: false,
    },
    status: 200,
  } as const;

  export const path = (query: Query) => {
    const variables: URLSearchParams = new URLSearchParams();
    for (const [key, value] of Object.entries(query as any))
      if (undefined === value) continue;
      else if (Array.isArray(value))
        value.forEach((elem: any) => variables.append(key, String(elem)));
      else variables.set(key, String(value));
    const location: string = "/admin/invitations/all";
    return 0 === variables.size
      ? location
      : `${location}?${variables.toString()}`;
  };
}
